import treatCurrentResponse from '@/store/modules/properties_360/treatPropertyResponse';
import BaseService from '@/services/services/tools/baseService';
import Properties360API from '@/services/api/internal/properties360.api';

const Properties360Service = new BaseService({
  api: Properties360API,
  treatCurrentResponse,
  urlParamsCurrent: {
    expand: 'maintenance,contract,business,usage,energetic,energy_management',
  },
});

export default Properties360Service;
